'use es6';

import _ from 'underscore';
import { createSelector } from 'reselect';
import { getContentFlexAreaSections } from 'ContentEditorUI/redux/selectors/moduleSelectorHelpers';
import { getLayoutSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { basicSelector, basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { getActiveBreakpointName, getShowHiddenElements } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { isHiddenForBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
import { getSelectedId } from 'EmailEditorUI/redux/selectors/selected';
export const getSections = createSelector([getContentFlexAreaSections], flexAreaSections => flexAreaSections);
export const getNumSections = createSelector(getSections, sections => sections.size);
export const getIsSectionBoxedHelper = (layoutSettings, sectionIndex) => {
  return layoutSettings.get('boxed') && sectionIndex >= layoutSettings.get('boxFirstElementIndex') && sectionIndex <= layoutSettings.get('boxLastElementIndex');
};
export const getIsSectionBoxedHelperImmer = (layoutSettings, sectionIndex) => {
  return layoutSettings.boxed && sectionIndex >= layoutSettings.boxFirstElementIndex && sectionIndex <= layoutSettings.boxLastElementIndex;
};
export const getElementsCoordinatesFromSectionHelper = section => _.flatten(section.get('columns').map((c, columnIndex) => c.get('widgets').map((elementId, elementIndex) => ({
  id: elementId,
  index: elementIndex,
  columnIndex
}))).toJS());
export const getShouldShowHubspotBranding = basicSelector(state => state.renderedModules && state.renderedModules['brandingSection']);
export const getSectionById = basicSelectorWithStats((state, id) => getSections(state).find(section => section.get('id') === id));
export const getSelectedSection = createSelector([getSections, getSelectedId], (sections, id) => sections.get(id));
export const getSectionIds = createSelector([getSections], sections => sections.map(s => s.get('id')));
export const getSelectedSectionId = createSelector([getSelectedId, getSectionIds], (selectedId, sectionIds) => sectionIds.get(selectedId));
export const getSectionIndex = basicSelectorWithStats((state, id) => getSections(state).findIndex(section => section.get('id') === id));
export const getIsSelectedSectionBoxed = createSelector([getSelectedId, getLayoutSettings], (selectedIndex, layoutSettings) => getIsSectionBoxedHelper(layoutSettings, selectedIndex));
export const getIsSelectedSectionLastBeforeBranding = createSelector([getSelectedId, getSections, getShouldShowHubspotBranding], (selectedIndex, sections, hasHubspotBranding) => {
  return hasHubspotBranding && selectedIndex === sections.size - 1;
});
export const countElementsInSection = section => section.get('columns').map(c => c.get('widgets').size).reduce((acc, count) => acc + count, 0);
export const sectionIsEmpty = section => {
  return !section.get('columns').find(c => !c.get('widgets').isEmpty());
};
export const findContainingSection = (sections, moduleId) => {
  return sections.find(section => section.get('columns').find(column => column.get('widgets').find(widget => widget === moduleId)));
};
export const getHasVisibleSectionsForActiveBreakpoint = createSelector([getSections, getActiveBreakpointName, getShowHiddenElements], (sections, activeBreakpointName, showHiddenElements) => {
  if (showHiddenElements && sections.size > 0) {
    return true;
  }
  return sections.size > 0 && !sections.every(section => isHiddenForBreakpoint(activeBreakpointName, section.get('style')));
});